import Box from '@/components/Unistyles/Box';
import Text from './Text';

export default function EmptyPlaceholder({ message }: { message: string }) {
  return (
    <Box flex center p="xl">
      <Text center variant="typographySecondary">
        {message}
      </Text>
    </Box>
  );
}
